var _symbol, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "_bell",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line",
    d: "M55.5,9.9l1.7-1.7c0.8-0.8,0.8-2.5,0-3.3c-0.8-0.8-2.5-0.8-3.3,0l-1.6,1.7C48.4,3.7,44.3,2,39.7,2c-6.2,0-12.4,2.9-17.4,7.9             c-5.8,5.8-9.5,5.8-12.4,6.2c-2.1,0-4.2,0.4-5.8,2.1c-1.7,1.2-2.1,3.3-2.1,5c0,2.1,0.8,3.7,2.5,5.4L33.9,58c1.2,1.2,3.3,2.1,5,2.1             c1.7,0,3.7-0.8,5-2.1c1.7-1.7,2.1-4.2,2.1-5.8c0.4-2.9,0.4-6.6,6.2-12.4C61.3,30.6,62.5,18.6,55.5,9.9z M13.2,57.1             c3.7,3.7,9.9,3.7,13.7,0L13.2,43.4C9,47.2,9,53.4,13.2,57.1z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "an1",
    attributeName: "d",
    begin: "0s;an2.end",
    dur: "0.3s",
    from: "M55.5,9.9l1.7-1.7c0.8-0.8,0.8-2.5,0-3.3c-0.8-0.8-2.5-0.8-3.3,0l-1.6,1.7C48.4,3.7,44.3,2,39.7,2c-6.2,0-12.4,2.9-17.4,7.9             c-5.8,5.8-9.5,5.8-12.4,6.2c-2.1,0-4.2,0.4-5.8,2.1c-1.7,1.2-2.1,3.3-2.1,5c0,2.1,0.8,3.7,2.5,5.4L33.9,58c1.2,1.2,3.3,2.1,5,2.1             c1.7,0,3.7-0.8,5-2.1c1.7-1.7,2.1-4.2,2.1-5.8c0.4-2.9,0.4-6.6,6.2-12.4C61.3,30.6,62.5,18.6,55.5,9.9z M13.2,57.1             c3.7,3.7,9.9,3.7,13.7,0L13.2,43.4C9,47.2,9,53.4,13.2,57.1z",
    to: "M52.6,7.6L54,5.6c0.7-1,0.4-2.6-0.6-3.3c-1-0.7-2.6-0.4-3.3,0.6l-1.3,1.9c-4.2-2.2-8.5-3.2-13-2.4             c-6.1,1-11.8,4.9-15.8,10.7c-4.7,6.7-8.4,7.3-11.2,8.2c-2,0.3-4,1.1-5.4,3c-1.4,1.5-1.5,3.6-1.2,5.3c0.3,2,1.5,3.5,3.3,4.9l34,24.1             c1.4,1,3.6,1.5,5.2,1.2c1.6-0.3,3.5-1.4,4.6-2.9c1.4-1.9,1.3-4.4,1.1-6.1c-0.1-2.9-0.7-6.6,4.1-13.3C61.8,27,61,14.9,52.6,7.6z             M12.9,55.2c4.3,3.1,10.4,2,13.5-2.3L10.6,41.7C7.1,46.1,8.1,52.3,12.9,55.2z"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "an2",
    attributeName: "d",
    begin: "an1.end",
    dur: "0.3s",
    from: "M52.6,7.6L54,5.6c0.7-1,0.4-2.6-0.6-3.3c-1-0.7-2.6-0.4-3.3,0.6l-1.3,1.9c-4.2-2.2-8.5-3.2-13-2.4             c-6.1,1-11.8,4.9-15.8,10.7c-4.7,6.7-8.4,7.3-11.2,8.2c-2,0.3-4,1.1-5.4,3c-1.4,1.5-1.5,3.6-1.2,5.3c0.3,2,1.5,3.5,3.3,4.9l34,24.1             c1.4,1,3.6,1.5,5.2,1.2c1.6-0.3,3.5-1.4,4.6-2.9c1.4-1.9,1.3-4.4,1.1-6.1c-0.1-2.9-0.7-6.6,4.1-13.3C61.8,27,61,14.9,52.6,7.6z             M12.9,55.2c4.3,3.1,10.4,2,13.5-2.3L10.6,41.7C7.1,46.1,8.1,52.3,12.9,55.2z",
    to: "M55.5,9.9l1.7-1.7c0.8-0.8,0.8-2.5,0-3.3c-0.8-0.8-2.5-0.8-3.3,0l-1.6,1.7C48.4,3.7,44.3,2,39.7,2c-6.2,0-12.4,2.9-17.4,7.9             c-5.8,5.8-9.5,5.8-12.4,6.2c-2.1,0-4.2,0.4-5.8,2.1c-1.7,1.2-2.1,3.3-2.1,5c0,2.1,0.8,3.7,2.5,5.4L33.9,58c1.2,1.2,3.3,2.1,5,2.1             c1.7,0,3.7-0.8,5-2.1c1.7-1.7,2.1-4.2,2.1-5.8c0.4-2.9,0.4-6.6,6.2-12.4C61.3,30.6,62.5,18.6,55.5,9.9z M13.2,57.1             c3.7,3.7,9.9,3.7,13.7,0L13.2,43.4C9,47.2,9,53.4,13.2,57.1z"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_bell",
    fill: "#8D45B5",
    width: 64,
    height: 64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon_bell.5d431acb3deaee340558093491776c68.svg";
export { ForwardRef as ReactComponent };